import Form from '@/components/Form.vue';

export default {
    name: 'Home',
  
    components: {
      Form,
    },
  
    data: () => ({
      //
    }),
    created() {
        // console.warn(this.$route);

        if(this.$route.query && this.$route.query.path == "data") {
            this.$router.push({ path: '/data' })
        }

    }    
  };